import Vue from 'vue'

import VueRouter from 'vue-router'

Vue.use(VueRouter)

import jwtDecode from 'jwt-decode'
import session from '@store/modules/session'
import store from '@store/index';
import terms from '@store/modules/terms'

const routes = [
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@views/client/Dashboard.vue'),
        beforeEnter: (to, from, next) => {
            //let user = JSON.parse(localStorage.getItem('access_avatar'));
            if (store.getters["moduleAvatar/avatar"].role === 'Estructurador')
                next({name: 'structuring-dashboard'})
            else next()
        }
    },
    {
        path: '/normas',
        name: 'rules',
        component: () => import('@views/feeder/rules.vue'),
        beforeEnter: (to, from, next) => {
            next()
        }
    },
    {
        path: '/mormas/carga-masiva',
        name: 'load-file-rules',
        component: () => import('@views/feeder/LoadRules.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('CLI')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/detalle-asuntos/:id',
        name: 'detail-regulatory-affair',
        component: () => import('@views/feeder/DetailRegulatoryAffairs.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('CLI')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/estructurador/dashboard',
        name: 'structuring-dashboard',
        component: () => import('@views/structuring/Dashboard.vue'),
        beforeEnter: (to, from, next) => {
            // let user = JSON.parse(localStorage.getItem('access_avatar'));
            if (store.getters["moduleAvatar/avatar"].role !== 'Estructurador') next({name: 'dashboard'})
            else next()
        }
    },
    {
        path: '/procesos',
        name: 'processes',
        component: () => import('@views/client/Processes.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('CUMP')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/procesos/detalle/:id',
        name: 'processes-detail',
        component: () => import('@views/client/ProcessesDetail.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('CUMP')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/procesos/detalle/:id/cumplimiento/:idCompliance',
        name: 'processes-detail-compliance',
        component: () => import('@views/client/ProcessesDetail.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('CUMP')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/cumplimiento',
        name: 'compliance',
        component: () => import('@views/client/Compliance.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('CUMP')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/reportes',
        name: 'reports',
        component: () => import('@views/client/Reports.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('REP')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/buscador',
        name: 'search',
        component: () => import('@views/client/Search.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('BUS')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/clientes',
        name: 'structuring-customers',
        component: () => import('@views/structuring/Customers.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('CLI')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/crear-tenant/',
        name: 'create-tenant',
        component: () => import('@views/structuring/CreateTenant.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('CLI')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/editar-tenant/:id',
        name: 'edit-tenant',
        component: () => import('@views/structuring/CreateTenant.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('CLI')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/usuarios',
        name: 'structuring-users',
        component: () => import('@views/structuring/Users.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('USU')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/usuarios/carga-masiva',
        name: 'structuring-users-bulk-load',
        component: () => import('@views/structuring/UsersBulkLoad.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('CLI-CLIUSERADD')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/procesos-estructurador',
        name: 'processes-structure',
        component: () => import('@views/structuring/ProcessesStructure.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('CLI-CLIPRO')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/procesos-estructurador/carga-masiva',
        name: 'load-file-process',
        component: () => import('@views/structuring/LoadFileProcess.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('CLI-CLIPRO')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/procesos-estructurador/asuntos/:id',
        name: 'processes-structure-affair',
        component: () => import('@views/structuring/AffairAssociation.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('CLI-CLIPRO')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/administrar-asuntos-normativos',
        name: 'manage-regulatory-affairs',
        component: () => import('@views/feeder/RegulatoryAffairs.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('ASNNORM')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/estructurador-diagnostico',
        name: 'structuring-diagnosis',
        component: () => import('@views/structuring/Diagnosis.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('CLI-CLIPRO')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@views/Login.vue'),
    },
    {
        path: '/login/sso/:id',
        name: 'login-sso',
        component: () => import('@views/Login.vue'),
    },
    {
        path: '/restablecer-contrasena',
        name: 'password-reset',
        component: () => import('@views/global/passwordReset.vue'),
    },
    {
        path: '/self-password-change/:encrypted',
        name: 'self-password-change',
        component: () => import('@views/global/selfPasswordChange.vue'),
    },
    {
        path: '/terminos-condiciones',
        name: 'terms',
        component: () => import('@views/global/TerminosCondiciones.vue'),
    },
    {
        path: '/switchTenant',
        name: 'switchTenant',
        beforeEnter: (to, from, next) => {
            console.log(store.getters["moduleAvatar/avatar"])
            if (store.getters["moduleAvatar/avatar"] != null) {
                if (store.getters["moduleAvatar/avatar"].role === 'Estructurador')
                    next({name: 'structuring-dashboard'})
                else
                    next({name: 'dashboard'})
            } else
                next({name: 'login'})
        }
    },
    {
        path: '/tema-subtema',
        name: 'structuring-topic-subtopic',
        component: () => import('@views/structuring/TopicSubtopic.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('TOPIC')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '/estructurador/reporte-detallado-procesos',
        name: 'structuring-detail-report-process',
        component: () => import('@views/structuring/ReportsStructuring.vue'),
        beforeEnter: (to, from, next) => {
            if (!Vue.prototype.$validPermission('REPORT_STR')) next({name: 'login'})
            else next()
        }
    },
    {
        path: '*',
        redirect: '/login'
    },
    {
        path: '/reportes/estadistica-cumplimientos',
        name: 'reporte-estadistica-cumplimientos',
        component: () => import('@views/reports/compliances/Index.vue'),
    },
]

const router = new VueRouter({
    history: true,
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    var publicViews = ['login', 'login-sso', 'password-reset', 'terms', 'self-password-change'];
    if (!publicViews.includes(to.name)) {
        let token = session.state.token;

        if (!token) {
            next({name: 'login'});
            return;
        }

        try {
            const {exp} = jwtDecode(token);
            if (exp < (new Date().getTime() / 1000)) {
                Vue.prototype.$eventHub.$emit('showExpiredSession');
            }
        } catch (e) {
            console.log(e);
            next({name: 'login'});
        }
    }
    next()
})

export default router
